<template>
  <div class="headerBox">
    <!-- LOGO、登录、国际化 -->
    <div class="headerTopBox">
      <div class="header_logo" @click="logoClick()">
        <img
          class="header_logo_img"
          src="@/assets/images/logo.png"
          alt="logo_img"
        />
        <div class="hidden-xs-only">
          <div class="pageTitle" v-if="i18nText === 'zh'">
            珠海翔翼航空技术有限公司
          </div>
          <div
            class="pageDesc"
            :style="{
              'font-size': i18nText === 'zh' ? '' : '16px',
              'font-weight': i18nText === 'zh' ? '' : 'bold',
            }"
          >
            Zhuhai Xiangyi Aviation Technology Co., Ltd
          </div>
        </div>
      </div>
      <div class="heade_options">
        <div class="i18nBox">
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="i18nDownSelect">
              <img
                class="i18nIcon"
                src="@/assets/images/icon/i18n.png"
                :alt="$t('navbar.language')"
              />
              <div style="width: 60px">
                {{ i18nText == "en" ? "English" : "简体中文" }}
              </div>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh">简体中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 登录隐藏 -->
        <div v-if="false" >
          <div v-if="!token" class="loginBox" @click="toLogin">
            <img
              class="loginBtnImg"
              src="@/assets/images/icon/login.png"
              alt=""
            />
            <div class="font">{{ $t("navbar.login") }}</div>
          </div>
          <div v-if="token">
            <el-dropdown>
              <div class="loginBox">
                <img
                  class="loginBtnImg"
                  v-if="userInfo.avatar"
                  :src="userInfo.avatar"
                />
                <img
                  class="loginBtnImg"
                  v-else
                  src="@/assets/images/icon/login.png"
                  alt="loginImg"
                />
                <div
                  style="
                    min-width: 60px;
                    max-width: 50vw;
                    text-overflow: ellipsis;
                  "
                >
                  {{ userInfo.username }}
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="toLogout">注销</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <login ref="login" @loginSuccess="loginSuccess" />
        </div>
        <!-- PC端隐藏 -->
        <div class="menuFoldBox hidden-md-and-up">
          <el-dropdown trigger="click" @command="handSelectClick">
            <span class="menuFold_icon i18nDownSelect">
              <i class="el-icon-s-unfold el-icon--center"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/">{{
                $t("route.Home")
              }}</el-dropdown-item>
              <!-- <el-dropdown-item command="2">{{$t('route.ProductCenter')}}</el-dropdown-item> -->
              <!-- <el-dropdown-item command="3">{{$t('route.Department')}}</el-dropdown-item> -->
              <el-dropdown-item :command="companyProfileList[0].path">{{
                $t("route.companyProfile")
              }}</el-dropdown-item>
              <el-dropdown-item command="/newsInformation">{{
                $t("route.newsInformation")
              }}</el-dropdown-item>
              <!-- <el-dropdown-item command="/departmentIntroduction">{{$t("route.departmentIntroduction")}}</el-dropdown-item> -->
              <el-dropdown-item command="/product">{{
                $t("route.ProductCenter")
              }}</el-dropdown-item>
              <!-- <el-dropdown-item command="/resourceCenter">{{
                $t("route.ResourceLibrary")
              }}</el-dropdown-item> -->
              <el-dropdown-item command="/pilotService">{{
                $t("route.Pilot")
              }}</el-dropdown-item>
              <el-dropdown-item command="/ContactUs">{{
                $t("route.Contact")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="menuBox hidden-sm-and-down">
      <!-- 导航 -->
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#32589f"
        text-color="#ffffffb0"
        active-text-color="#ffffff"
        @select="handleSelect"
        :router="true"
      >
        <el-menu-item index="/"
          ><span>{{ $t("route.Home") }}</span></el-menu-item
        >
        <!-- <el-menu-item index="2"><span>{{$t('route.ProductCenter')}}</span></el-menu-item> -->
        <!-- <el-menu-item index="3"><span>{{$t('route.Department')}}</span></el-menu-item> -->
        <el-submenu index="/companyProfile" popper-class="submenuColor">
          <template slot="title">
            <span @click="toFirstRoute(companyProfileList[0].path)">{{
              $t("route.companyProfile")
            }}</span>
          </template>
          <el-menu-item
            v-for="(item, index) in companyProfileList"
            :key="index"
            :index="item.path"
            >{{ item.title }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item index="/newsInformation"
          ><span>{{ $t("route.newsInformation") }}</span></el-menu-item
        >
        <!-- <el-menu-item index="/departmentIntroduction"><span>{{$t("route.departmentIntroduction")}}</span></el-menu-item> -->
        <el-submenu index="/product" popper-class="submenuColor product">
          <template slot="title">
            <span @click="toFirstRoute(productCenterList[0].path)">{{
              $t("route.ProductCenter")
            }}</span>
          </template>
          <div class="productList">
            <div v-for="(item, index) in productCenterList" v-show="index > 0">
              <el-menu-item :key="index" :index="item.path">{{
                i18nText === "zh" ? item.title : item.en_title
              }}</el-menu-item>
            </div>
          </div>
          <!-- <el-row class="productList">
            <el-col
              :span="12"
              v-for="(item, index) in productCenterList"
              v-show="index > 0"
            >
              <el-menu-item :key="index" :index="item.path">{{
                i18nText === "zh" ? item.title : item.en_title
              }}</el-menu-item>
            </el-col>
          </el-row> -->
        </el-submenu>
        <el-submenu index="/pilotService" popper-class="submenuColor">
          <template slot="title">
            <span @click="toFirstRoute(pilotServiceList[0].path)">{{
              $t("route.Pilot")
            }}</span>
          </template>
          <el-menu-item
            v-show="index > 0"
            v-for="(item, index) in pilotServiceList"
            :key="index"
            :index="item.path"
            >{{ item.title }}</el-menu-item
          >
        </el-submenu>
        <!-- <el-menu-item index="/resourceCenter"
          ><span>{{ $t("route.ResourceLibrary") }}</span></el-menu-item
        > -->
        <el-submenu index="/ContactUs" popper-class="submenuColor">
          <template slot="title">
            <span @click="toFirstRoute(contactList[0].path)">{{
              $t("route.Contact")
            }}</span>
          </template>
          <el-menu-item
            v-for="(item, index) in contactList"
            :key="index"
            :index="item.path"
            >{{ item.title }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import login from "@/views/login/login.vue";
import * as acticleApi from "@/api/acticle/acticle";
import { localStorage } from "../utils/storage.js";
import { logout } from "@/api/login";
import i18n from "../assets/i18n";
import { mixins } from "@/mixins/list";
export default {
  name: "headerPage",
  mixins: [mixins],
  components: { login },
  props: {
    msg: String,
  },
  data() {
    return {
      i18nText: "",
      // activeIndex: "/", //d导航菜单默认选中
      //登录信息
      token: "",
      userInfo: {},
    };
  },
  mounted () {
    // 默认读取缓存语言
    const lang = localStorage.get("language") || "zh";
    this.i18nText = lang;
    if (localStorage.get("xy-web-token")) {
      this.token = localStorage.get("xy-web-token");
      this.userInfo = JSON.parse(localStorage.get("xy-web-userInfo"));
    }
    this.getProduct();
  },
  methods: {
    toFirstRoute(path) {
      //跳转往第一个路由
      this.$router.push(path);
      this.handleSelect(path);
    },
    // 产品与服务
    getProduct() {
      acticleApi.getChildCategory({ name: "product_show" }).then((res) => {
        for (const item of res.data.childrens) {
          this.productCenterList.push({
            name: item.title,
            en_title: item.en_title,
            title: item.title,
            path: "/productCenter/productCard/" + item.id,
          });
        }
        const arr = this.productCenterList;
        this.productCenterList = arr.filter((item, index, self) => {
          return self.findIndex((el) => el.path == item.path) === index;
        });
      });
    },
    // logo点击
    logoClick() {},
    // 导航菜单选中
    handleSelect(path) {
      if (
        ["https://newlms.zhftc.com", "https://www.csairgroup.cn",'https://xylms.zhftc.com'].includes(path)
      ) {
        window.open(path, "_blank");
        this.$router.go(0);
      } else {
        this.$emit("resetScrollTop");
      }
    },
    // 手机导航点击
    handSelectClick(e) {
      this.$router.push({
        path: e,
      });
    },
    // 国际化下拉选中
    handleCommand(command) {
      this.changeLanguage(command);
    },
    // 语言切换
    changeLanguage(lang) {
      i18n.locale = lang;
      localStorage.set("language", lang);
      this.i18nText = lang;
      this.$router.go(0);
    },
    //登录
    toLogin() {
      this.$refs.login.open();
    },
    //注销
    toLogout() {
      logout()
        .then((res) => {
          if (res.code == 0) {
            localStorage.remove("xy-web-token");
            localStorage.remove("xy-web-userInfo");
            this.$router.go(0);
          }
        })
        .catch((err) => {});
    },
    loginSuccess() {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped>
.headerBox {
  width: 100%;
}
.headerTopBox {
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header_logo {
  display: flex;
  align-items: center;
  height: 60px;
  cursor: pointer;
}
.header_logo_img {
  width: auto;
  height: 50px;
  cursor: pointer;
  margin-right: 10px;
}
.header_logo_img:hover {
  opacity: 0.9;
}

.productList {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.pageTitle {
  font-size: 18px;
  color: #333333;
  margin-bottom: 4px;
}
.pageDesc {
  font-size: 12px;
  color: #333333;
}

/* 顶部右侧操作 */
.i18nDownSelect,
.loginBox {
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  color: #333333;
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: all 0.3s;
  background: #ffffff;
  border-radius: 3px;
}
.i18nDownSelect:hover,
.loginBox:hover {
  background: #f4f4f4;
}
.loginBox .font {
  width: 30px;
}
/* .i18nDownSelect:active,.loginBox:active{
		background: #f4f4f4;
	} */
.i18nIcon,
.loginBtnImg {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.heade_options {
  display: flex;
  align-items: center;
}
.menuFold_icon {
  font-size: 18px;
}

/* 导航 */
.menuBox {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 0 20px;
  background-color: #32589f;
  display: flex;
  justify-content: flex-end;
}
.el-menu--horizontal > .el-submenu.is-active /deep/ .el-submenu__title,
.el-menu--horizontal > .el-menu-item.is-active {
  /* border-bottom: 4px solid transparent; */
  border-bottom-color: transparent !important ;
  font-size: 18px;
  /* font-weight: 700; */
  text-shadow: 1px 0 0 currentColor;
}
.el-menu--horizontal > .el-submenu.is-active /deep/ .el-submenu__title::before,
.el-menu--horizontal > .el-menu-item.is-active::before {
  content: "";
  width: 20px;
  position: absolute;
  bottom: 0.4vmax;
  border-bottom: 4px solid #ffffff;
  margin: auto;
  left: 0;
  right: 0;
  border-radius: 5px;
}

.el-menu--horizontal > .el-submenu.is-active /deep/ .el-submenu__title::before {
  right: 22px;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal
  > .el-submenu
  /deep/
  .el-submenu__title:not(.is-disabled):hover,
.el-menu--horizontal
  > .el-submenu
  /deep/
  .el-submenu__title:not(.is-disabled):focus {
  /* font-weight: 700; */
  background-color: #32589f !important;
  text-shadow: 1px 0 0 currentColor;
}

.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu /deep/ .el-submenu__title {
  font-size: 16px;
  color: #ffffff !important;
}
.el-menu--horizontal > .el-submenu /deep/ .el-submenu__title i {
  color: #ffffff !important;
}
@media screen and (max-width: 768px) {
  .headerBox {
    overflow: hidden;
  }
  .headerTopBox {
    box-sizing: content-box;
  }
  .header_logo_img {
    height: 40%;
  }
  .i18nBox {
    width: 35%;
  }
  .loginBox .font {
    width: 50px;
  }
}
</style>
